// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_n6-0";
export var buttonContainer = "_n6-3";
export var cancelButton = "_n6-4";
export var headerSection = "_n6-6";
export var headerTitle = "_n6-9";
export var messageSideLeft = "_n6-1";
export var messageSideRight = "_n6-2";
export var orderNumberContainer = "_n6-7";
export var orderNumberLabel = "_n6-8";
export var submitButton = "_n6-5";